import { Component } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'lib-information-dialog',
    templateUrl: './information-dialog.component.html',
    styleUrls: ['./information-dialog.component.css'],
})
export class InformationDialogComponent {
    public static Close: string = 'Close';

    public title: string;
    public message: string;
    public styleBackgroundClass: string = 'bg-warning';

    constructor(
        private modalService: BsModalService,
        public bsModalRef: BsModalRef
    ) {}

    public onClose(e: MouseEvent): void {
        e.preventDefault();
        this.closeForm(InformationDialogComponent.Close);
    }

    private closeForm(reason?: string): void {
        this.modalService.setDismissReason(reason);
        this.modalService.hide(this.bsModalRef.id);
    }
}
